import './NewUniqueResource.css';

function NewUniqueResource({ onClose, resource }) {
  return (
    <div className='dialogbackground' onClick={onClose}>
      <div className='newuniqueresourcedialog'>
        <div className='newuniqueresourceheader'>Unique resource found!</div>
        <img alt="" src={require(`./images/${resource.id}.svg`).default}></img>
        <div className='newuniqueresource'>{resource.name}</div>
      </div>
    </div>
  );
}

export default NewUniqueResource;
